export enum ParticipationEnum {
    event = 1,
    project = 2
}